<div class="supplier-view-container">
  <div class="loading-state" *ngIf="loading">
    <p>Loading supplier details...</p>
  </div>
  
  <div *ngIf="!loading && supplier">
    <!-- Header Section -->
    <div class="view-details-header">
    <button type="button" class="view-back-btn" (click)="onGoBack()">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>Back</span>
    </button>
    <div class="header-left">
      <div class="header-name-row">
        <h2 class="company-name">{{supplier.supplierId || '-' }} ({{ supplier.companyName || supplier.name || '--' }})</h2>
        <span class="status-badge-view" [ngClass]="supplier.isActive ? 'status-active-view' : 'status-inactive-view'">
          {{ supplier.isActive ? 'Active' : 'Inactive' }}
        </span>
      </div>
      <div class="company-location-view">{{ supplier.city || '' }}{{ supplier.city && supplier.country ? ', ' : '' }} {{ supplier.country || '--' }}</div>
    </div>
  </div>

  <!-- Tabs Section -->
  <div class="view-details-tabs">
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'Profile'"
      (click)="onTabChange('Profile')">
      Profile
    </button>
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'Product Category'"
      (click)="onTabChange('Product Category')">
      Product Category
    </button>
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'Active Quote'"
      (click)="onTabChange('Active Quote')">
      Active Quote
    </button>
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'Archived Quote'"
      (click)="onTabChange('Archived Quote')">
      Archived Quote
    </button>
  </div>

  <!-- Tab Content -->
  <div class="view-details-content">
    <!-- Profile Tab -->
    <div class="tab-content" *ngIf="activeTab === 'Profile'">
      <div class="view-form-card">
        <!-- Company Details Section -->
        <div class="form-section">
          <h4 class="section-title">Company Details</h4>
          <div class="form-row">
            <div class="form-group">
              <label>Company Name<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control view-input" [value]="supplier.companyName || supplier.name || ''" readonly>
            </div>
            <div class="form-group">
              <label>First Name<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control view-input" [value]="supplier.firstName || ''" readonly>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Last Name</label>
              <input type="text" class="form-control view-input" [value]="supplier.lastName || ''" readonly>
            </div>
            <div class="form-group">
              <label>Role</label>
              <input type="text" class="form-control view-input" [value]="supplier.role || 'Supplier'" readonly>
            </div>
          </div>
        </div>

        <!-- Contact Information Section -->
        <div class="form-section">
          <h4 class="section-title">Contact Information</h4>
          <div class="form-row">
            <div class="form-group">
              <label>Email ID<span class="required-asterisk">*</span></label>
              <input type="email" class="form-control view-input" [value]="supplier.email || ''" readonly>
            </div>
            <div class="form-group">
              <label>Phone No<span class="required-asterisk">*</span></label>
              <div class="phone-input-group">
                <input type="text" class="form-control phone-code view-input" [value]="supplier.phoneCountryCode || 'IN +91'" readonly>
                <input type="text" class="form-control phone-number view-input" [value]="supplier.phone || ''" readonly>
              </div>
            </div>
          </div>
        </div>

        <!-- Address Section -->
        <div class="form-section">
          <h4 class="section-title">Address</h4>
          <div class="form-row">
            <div class="form-group">
              <label>Address Line 1<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control view-input" [value]="supplier.addressLine1 || ''" readonly>
            </div>
            <div class="form-group">
              <label>Address Line 2</label>
              <input type="text" class="form-control view-input" [value]="supplier.addressLine2 || ''" readonly>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>City<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control view-input" [value]="supplier.city || ''" readonly>
            </div>
            <div class="form-group">
              <label>State<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control view-input" [value]="supplier.state || ''" readonly>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Country<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control view-input" [value]="supplier.country || 'India'" readonly>
            </div>
            <div class="form-group">
              <label>Pincode<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control view-input" [value]="supplier.pincode || ''" readonly>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Product Category Tab -->
    <div class="tab-content" *ngIf="activeTab === 'Product Category'">
      <div class="view-form-card">
        <!-- Search and Filter Section -->
        <div class="category-filters-section">
          <div class="filter-row">
            <div class="search-input-wrapper">
              <input 
                type="text" 
                class="search-input" 
                placeholder="Search by Product Category"
                [(ngModel)]="searchTerm"
                (input)="onSearchChange()">
              <svg class="search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 14L11.1 11.1" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <!-- <div class="filter-dropdown-wrapper">
              <select 
                class="filter-dropdown" 
                [(ngModel)]="selectedCategoryFilter"
                (change)="applyFilters()">
                <option value="">Filter by Product Category</option>
              </select>
              <svg class="dropdown-icon" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div> -->
            <div class="filter-dropdown-wrapper">
              <select 
                class="filter-dropdown" 
                [(ngModel)]="selectedStatusFilter"
                (change)="applyFilters()">
                <option value="">Filter by Status</option>
                <option value="Active">Active</option>
                <option value="Deactive">Deactive</option>
              </select>
              <svg class="dropdown-icon" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <button class="reset-btn" (click)="resetFilters()">Reset</button>
          </div>
        </div>

        <!-- Category Count -->
        <div class="category-count-section">
          <h3 class="category-count-title">Product Category Shared ({{ categoryCount }})</h3>
        </div>

        <!-- Loading State -->
        <div *ngIf="loadingCategories" class="loading-categories">
          <p>Loading categories...</p>
        </div>

        <!-- Categories Table -->
        <div *ngIf="!loadingCategories" class="categories-table-container">
          <table class="categories-table" *ngIf="filteredCategories.length > 0">
            <thead>
              <tr>
                <th>Product Category</th>
                <th>Shared on (DD/MM/YYYY)</th>
                <th>Status</th>
                <th>Shared by</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let category of filteredCategories">
                <td>
                  <a 
                    href="javascript:void(0)" 
                    class="category-link"
                    (click)="navigateToCategory(category._id)">
                    {{ category.name }}
                    <svg class="external-link-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.0833 2.91667V11.0833H2.91667" stroke="#1E3A8A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M11.0833 2.91667L5.83333 8.16667M11.0833 2.91667H8.16667M11.0833 2.91667V5.83333" stroke="#1E3A8A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>
                </td>
                <td>{{ formatDate(category.sharedAt) }}</td>
                <td>
                  <span class="status-badge" [ngClass]="getStatusClass(category.isActive)">
                    {{ getStatusText(category.isActive) }}
                  </span>
                </td>
                <td>
                  <div class="shared-by-info">
                    <span class="shared-by-name">{{ category.sharedBy?.name || '--' }}</span>
                    <span *ngIf="category.sharedBy" class="shared-by-role">Role: {{ getUserRole(category.sharedBy) }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="filteredCategories.length === 0 && !loadingCategories" class="empty-categories">
            <p>No categories found.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Active Quote Tab -->
    <div class="tab-content" *ngIf="activeTab === 'Active Quote'">
      <div class="view-form-card">
        <!-- Search and Filter Section -->
        <div class="category-filters-section">
          <div class="filter-row">
            <div class="search-input-wrapper">
              <input 
                type="text" 
                class="search-input" 
                placeholder="Search by Quote ID or Product Name"
                [(ngModel)]="quoteSearchTerm"
                (input)="onQuoteSearchChange()">
              <svg class="search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 14L11.1 11.1" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="filter-dropdown-wrapper">
              <select 
                class="filter-dropdown" 
                [(ngModel)]="selectedQuoteCategoryFilter"
                (change)="onQuoteCategoryFilterChange()">
                <option value="">Filter by Product Category</option>
                <option *ngFor="let cat of quoteCategories" [value]="cat._id">{{ cat.name }}</option>
              </select>
              <svg class="dropdown-icon" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="filter-dropdown-wrapper">
              <select 
                class="filter-dropdown" 
                [(ngModel)]="selectedValidityDateFilter"
                (change)="onValidityDateFilterChange()">
                <option value="">Filter by Validity Date</option>
                <option value="active">Active</option>
                <option value="expired">Expired</option>
              </select>
              <svg class="dropdown-icon" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <button class="reset-btn" (click)="resetQuoteFilters()">Reset</button>
          </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="loadingQuotes && activeQuotes.length === 0" class="loading-categories">
          <p>Loading quotes...</p>
        </div>

        <!-- Quotes Table -->
        <div class="table-container" #activeQuoteTableContainer *ngIf="!loadingQuotes && activeQuotes.length > 0">
          <table class="quotes-table">
            <thead>
              <tr>
                <th>Quote ID</th>
                <th>Product</th>
                <th>Quoted on <span class="quote-label">(DD/MM/YYYY)</span></th>
                <th>Price</th>
                <th>Shipping Term</th>
                <th>Valid Upto <span class="quote-label">(DD/MM/YYYY)</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let quote of filteredActiveQuotes">
                <td class="quote-id-cell">
                  <div class="quote-id-text">{{ quote.quoteId || '--' }}</div>
                </td>
                <td class="product-cell">
                  <a 
                    href="javascript:void(0)" 
                    class="product-link"
                    (click)="navigateToProduct(quote.product?._id || quote.product)">
                    {{ quote.product?.name || quote.productDetails?.name || '--' }}
                  </a>
                  <div class="product-category-link" *ngIf="quote.category">
                    <span class="category-label">Product Category: </span>
                    <a 
                      href="javascript:void(0)" 
                      class="category-link"
                      (click)="navigateToCategoryFromQuote(quote.category._id)">
                      {{ quote.category.name }}
                    </a>
                  </div>
                </td>
                <td class="date-cell">{{ formatDate(quote.submittedAt || quote.createdAt) }}</td>
                <td class="price-cell">{{ formatPrice(quote) }}</td>
                <td class="shipping-cell">{{ getShippingTermDisplay(quote) }}</td>
                <td class="date-cell">{{ formatDate(quote.validityDate) }}</td>
              </tr>
            </tbody>
          </table>
          
          <!-- Infinite Scroll Loader -->
          <div class="infinite-scroll-loader" *ngIf="isLoadingMoreQuotes">
            <div class="loader-spinner"></div>
            <span>Loading more quotes...</span>
          </div>
          
          <!-- End of Data Message -->
          <div class="end-of-data" *ngIf="!hasMoreQuotes && !loadingQuotes && activeQuotes.length > 0">
            <p>No more active quotes to load</p>
          </div>
        </div>

        <div class="empty-state" *ngIf="!loadingQuotes && activeQuotes.length === 0">
          <p>No active quotes found</p>
        </div>
      </div>
    </div>

    <!-- Archived Quote Tab -->
    <div class="tab-content" *ngIf="activeTab === 'Archived Quote'">
      <div class="view-form-card">
        <!-- Search and Filter Section -->
        <div class="category-filters-section">
          <div class="filter-row">
            <div class="search-input-wrapper">
              <input 
                type="text" 
                class="search-input" 
                placeholder="Search by Quote ID or Product Name"
                [(ngModel)]="archivedQuoteSearchTerm"
                (input)="onArchivedQuoteSearchChange()">
              <svg class="search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 14L11.1 11.1" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="filter-dropdown-wrapper">
              <select 
                class="filter-dropdown" 
                [(ngModel)]="selectedArchivedQuoteCategoryFilter"
                (change)="onArchivedQuoteCategoryFilterChange()">
                <option value="">Filter by Product Category</option>
                <option *ngFor="let cat of archivedQuoteCategories" [value]="cat._id">{{ cat.name }}</option>
              </select>
              <svg class="dropdown-icon" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="filter-dropdown-wrapper">
              <select 
                class="filter-dropdown" 
                [(ngModel)]="selectedArchivedValidityDateFilter"
                (change)="onArchivedValidityDateFilterChange()">
                <option value="">Filter by Validity Date</option>
                <option value="expired">Expired</option>
              </select>
              <svg class="dropdown-icon" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <button class="reset-btn" (click)="resetArchivedQuoteFilters()">Reset</button>
          </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="loadingArchivedQuotes && archivedQuotes.length === 0" class="loading-categories">
          <p>Loading archived quotes...</p>
        </div>

        <!-- Quotes Table -->
        <div class="table-container" #archivedQuoteTableContainer *ngIf="!loadingArchivedQuotes && archivedQuotes.length > 0">
          <table class="quotes-table">
            <thead>
              <tr>
                <th>Quote ID</th>
                <th>Product</th>
                <th>Quoted on <span class="quote-label">(DD/MM/YYYY)</span></th>
                <th>Price</th>
                <th>Shipping Term</th>
                <th>Valid Upto <span class="quote-label">(DD/MM/YYYY)</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let quote of filteredArchivedQuotes">
                <td class="quote-id-cell">
                  <div class="quote-id-text">{{ quote.quoteId || '--' }}</div>
                </td>
                <td class="product-cell">
                  <a 
                    href="javascript:void(0)" 
                    class="product-link"
                    (click)="navigateToProduct(quote.product?._id || quote.product)">
                    {{ quote.product?.name || quote.productDetails?.name || '--' }}
                  </a>
                  <div class="product-category-link" *ngIf="quote.category">
                    <span class="category-label">Product Category: </span>
                    <a 
                      href="javascript:void(0)" 
                      class="category-link"
                      (click)="navigateToCategoryFromQuote(quote.category._id)">
                      {{ quote.category.name }}
                    </a>
                  </div>
                </td>
                <td class="date-cell">{{ formatDate(quote.submittedAt || quote.createdAt) }}</td>
                <td class="price-cell">{{ formatPrice(quote) }}</td>
                <td class="shipping-cell">{{ getShippingTermDisplay(quote) }}</td>
                <td class="date-cell">{{ formatDate(quote.validityDate) }}</td>
              </tr>
            </tbody>
          </table>
          
          <!-- Infinite Scroll Loader -->
          <div class="infinite-scroll-loader" *ngIf="isLoadingMoreArchivedQuotes">
            <div class="loader-spinner"></div>
            <span>Loading more quotes...</span>
          </div>
          
          <!-- End of Data Message -->
          <div class="end-of-data" *ngIf="!hasMoreArchivedQuotes && !loadingArchivedQuotes && archivedQuotes.length > 0">
            <p>No more archived quotes to load</p>
          </div>
        </div>

        <div class="empty-state" *ngIf="!loadingArchivedQuotes && archivedQuotes.length === 0">
          <p>No archived quotes found</p>
        </div>
      </div>
    </div>
    </div>
  </div>
  
  <div class="error-state" *ngIf="!loading && !supplier">
    <p>Supplier not found</p>
  </div>
</div>

